import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const ServingMultipleIndustries: React.FC = () => {
    return (
        <section className="serving-bg">
            <div className="container lg:container md:mx-auto">
                <div className="serving overflow-hidden relative">
                    <div className="row grid md:grid-cols-12">
                        <div className="md:col-start-3 lg:col-start-4 md:col-span-8 lg:col-span-6">
                            <div className="text-center serving-content relative z-[1]">
                                <h2 className="mb-4 fs-xl" data-aos="fade-up" data-aos-duration={1000} data-aos-delay={100}>
                                    Serving to Multiple Industries
                                </h2>
                                <p className="mb-6 pb-1" data-aos="fade-up" data-aos-duration={1000} data-aos-delay={200}>
                                    Since over a decade we&apos;ve worked for large and small clients in numerous sectors across
                                    the globe. We have built everything from enterprise apps to creative consumer-focused mobile
                                    apps and multiplayer games. You think it and we invent it.
                                </p>

                                <div className="btn-mask" data-aos="fade-up" data-aos-duration={1000} data-aos-delay={250}>
                                    <Link href="/work" className="btn btn-primary">
                                        Visit Portfolio
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="serving-logos">
                        <Image
                            src="/img/img-serving.webp"
                            width={1073}
                            height={503}
                            alt="img-serving-bg"
                            className="img-serving-bg hidden lg:block"
                        />
                        <Image
                            src="/img/blue-lines-tablet.webp"
                            width={594}
                            height={745}
                            alt="img-serving-bg"
                            className="img-serving-bg hidden md:block lg:hidden"
                        />
                        <Image
                            src="/img/blue-lines-mobile.webp"
                            width={594}
                            height={745}
                            alt="img-serving-bg"
                            className="img-serving-bg block md:hidden"
                        />
                        <div className="serving__logo serving__logo1 mw_move_y" data-aos="zoom-in" data-aos-duration={1000}>
                            <Image src="/img/icons/tabler-icon-dollar.svg" alt="icon-dollar" height={36} width={36} />
                        </div>
                        <div
                            className="serving__logo serving__logo2 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={100}
                        >
                            <Image
                                src="/img/icons/tabler-icon-vacuum-cleaner.svg"
                                height={36}
                                width={36}
                                alt="icon-vacuum-cleaner"
                            />
                        </div>
                        <div
                            className="serving__logo serving__logo3 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={200}
                        >
                            <Image src="/img/icons/tabler-icon-luggage.svg" height={36} width={36} alt="icon-luggage" />
                        </div>
                        <div
                            className="serving__logo serving__logo4 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={300}
                        >
                            <Image src="/img/icons/tabler-icon-marketplace.svg" height={36} width={36} alt="icon-marketplace" />
                        </div>
                        <div
                            className="serving__logo serving__logo5 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={100}
                        >
                            <Image src="/img/icons/tabler-icon-open-book.svg" height={36} width={36} alt="icon-open-book" />
                        </div>
                        <div
                            className="serving__logo serving__logo6 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={200}
                        >
                            <Image src="/img/icons/tabler-icon-building.svg" height={36} width={36} alt="icon-building" />
                        </div>
                        <div
                            className="serving__logo serving__logo7 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={300}
                        >
                            <Image
                                src="/img/icons/tabler-icon-american-football.svg"
                                height={36}
                                width={36}
                                alt="icon-football"
                            />
                        </div>
                        <div
                            className="serving__logo serving__logo8 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={100}
                        >
                            <Image src="/img/icons/tabler-icon-settings.svg" height={36} width={36} alt="icon-setting" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServingMultipleIndustries;
